import React, { FC } from "react";
import CoreModal from '@material-ui/core/Modal';
import styled from "styled-components";

interface Props {
    onClose: VoidFunction;
    open: boolean;
}

const Modal: FC<Props> = ({ children, open, onClose }) => {
    return (
        <CoreModal open={open} onClose={onClose}>
            <Inner>
                {children}
            </Inner>
        </CoreModal>
    );
}

const Inner = styled.div`
    width: 900px;
    max-width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -200px;
    margin-left: -400px;
    background-color: white;
    border-radius: 8px;
    padding: 16px;
`;

export default Modal;